import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth/store';
import { ForcePasswordChange } from '@/features/auth/ForcePasswordChange';

/** Gate the authenticated app. Unauthenticated users are sent to /login. */
export function ProtectedRoute() {
  const status = useAuthStore((s) => s.status);
  const mustChangePassword = useAuthStore((s) => s.profile?.mustChangePassword ?? false);
  const location = useLocation();

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  // A seeded/default credential must be rotated before the console is reachable;
  // the backend blocks every other admin route until then, so gate the UI too.
  if (mustChangePassword) {
    return <ForcePasswordChange />;
  }
  // 'unknown' is resolved synchronously by hydrate() before render; treat as allowed.
  return <Outlet />;
}
